var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageContact',{attrs:{"branch-primary":_vm.branchPrimary,"branches":typeof _vm.branches !== 'undefined' && _vm.branches && _vm.branches.entities ? _vm.branches.entities : [],"contact":this.$store.state.globals.contact}})
}
var staticRenderFns = []

export { render, staticRenderFns }